import { render, staticRenderFns } from "./Vfaq.vue?vue&type=template&id=ed12c2a0"
import script from "./Vfaq.vue?vue&type=script&lang=js"
export * from "./Vfaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports